import(/* webpackMode: "eager", webpackExports: ["ContactForm"] */ "/codebuild/output/src592612800/src/mtalkz.com/components/ContactForm.tsx");
;
import(/* webpackMode: "eager" */ "/codebuild/output/src592612800/src/mtalkz.com/components/CTA/CTA.tsx");
;
import(/* webpackMode: "eager" */ "/codebuild/output/src592612800/src/mtalkz.com/components/dynamic-zone/AnimatedFeatureGrid/AnimatedFeatureGrid.tsx");
;
import(/* webpackMode: "eager" */ "/codebuild/output/src592612800/src/mtalkz.com/components/dynamic-zone/ApiDocumentation/ApiDocumentation.tsx");
;
import(/* webpackMode: "eager" */ "/codebuild/output/src592612800/src/mtalkz.com/components/dynamic-zone/BlogsResources/BlogsResources.tsx");
;
import(/* webpackMode: "eager" */ "/codebuild/output/src592612800/src/mtalkz.com/components/dynamic-zone/CaseStudiesSection/CaseStudiesSection.tsx");
;
import(/* webpackMode: "eager" */ "/codebuild/output/src592612800/src/mtalkz.com/components/dynamic-zone/ContactSection/ContactSection.tsx");
;
import(/* webpackMode: "eager" */ "/codebuild/output/src592612800/src/mtalkz.com/components/dynamic-zone/CoreValuesBlock/CoreValuesBlock.tsx");
;
import(/* webpackMode: "eager" */ "/codebuild/output/src592612800/src/mtalkz.com/components/dynamic-zone/CTASection/CTASection.tsx");
;
import(/* webpackMode: "eager" */ "/codebuild/output/src592612800/src/mtalkz.com/components/dynamic-zone/DLTRegistration/DLTRegistration.tsx");
;
import(/* webpackMode: "eager" */ "/codebuild/output/src592612800/src/mtalkz.com/components/dynamic-zone/EventVideo/EventVideo.tsx");
;
import(/* webpackMode: "eager" */ "/codebuild/output/src592612800/src/mtalkz.com/components/dynamic-zone/FAQSection/FAQSection.tsx");
;
import(/* webpackMode: "eager" */ "/codebuild/output/src592612800/src/mtalkz.com/components/dynamic-zone/FeatureBlocks/FeatureBlocks.tsx");
;
import(/* webpackMode: "eager" */ "/codebuild/output/src592612800/src/mtalkz.com/components/dynamic-zone/FeatureGrid/FeatureGrid.tsx");
;
import(/* webpackMode: "eager" */ "/codebuild/output/src592612800/src/mtalkz.com/components/dynamic-zone/FutureOfCommunications/FutureOfCommunications.tsx");
;
import(/* webpackMode: "eager" */ "/codebuild/output/src592612800/src/mtalkz.com/components/dynamic-zone/GMap/GMap.tsx");
;
import(/* webpackMode: "eager" */ "/codebuild/output/src592612800/src/mtalkz.com/components/dynamic-zone/GridIconFeatures/GridIconFeatures.tsx");
;
import(/* webpackMode: "eager" */ "/codebuild/output/src592612800/src/mtalkz.com/components/dynamic-zone/HeadingCTA/HeadingCTA.tsx");
;
import(/* webpackMode: "eager" */ "/codebuild/output/src592612800/src/mtalkz.com/components/dynamic-zone/ImageCarousel/ImageCarousel.tsx");
;
import(/* webpackMode: "eager" */ "/codebuild/output/src592612800/src/mtalkz.com/components/dynamic-zone/JobOpenings/JobOpenings.tsx");
;
import(/* webpackMode: "eager" */ "/codebuild/output/src592612800/src/mtalkz.com/components/dynamic-zone/LeadershipSection/LeadershipSection.tsx");
;
import(/* webpackMode: "eager" */ "/codebuild/output/src592612800/src/mtalkz.com/components/dynamic-zone/MessagingSolutionsGrid/MessagingSolutionsGrid.tsx");
;
import(/* webpackMode: "eager" */ "/codebuild/output/src592612800/src/mtalkz.com/components/dynamic-zone/PartnershipBenefits/PartnershipBenefits.tsx");
;
import(/* webpackMode: "eager" */ "/codebuild/output/src592612800/src/mtalkz.com/components/dynamic-zone/PartnershipTypes/PartnershipTypes.tsx");
;
import(/* webpackMode: "eager" */ "/codebuild/output/src592612800/src/mtalkz.com/components/dynamic-zone/PricingComaprision/PricingComparison.tsx");
;
import(/* webpackMode: "eager" */ "/codebuild/output/src592612800/src/mtalkz.com/components/dynamic-zone/PricingComparisonSlider/PricingComparisonSlider.tsx");
;
import(/* webpackMode: "eager" */ "/codebuild/output/src592612800/src/mtalkz.com/components/dynamic-zone/related-articles.tsx");
;
import(/* webpackMode: "eager" */ "/codebuild/output/src592612800/src/mtalkz.com/components/dynamic-zone/SimpleHero/SimpleHero.tsx");
;
import(/* webpackMode: "eager" */ "/codebuild/output/src592612800/src/mtalkz.com/components/dynamic-zone/StripImageCTA/StripImageCTA.tsx");
;
import(/* webpackMode: "eager" */ "/codebuild/output/src592612800/src/mtalkz.com/components/dynamic-zone/SuccessMetrics/SuccessMetrics.tsx");
;
import(/* webpackMode: "eager" */ "/codebuild/output/src592612800/src/mtalkz.com/components/dynamic-zone/Table/Table.tsx");
;
import(/* webpackMode: "eager" */ "/codebuild/output/src592612800/src/mtalkz.com/components/dynamic-zone/TestimonialsSection/TestimonialsSection.tsx");
;
import(/* webpackMode: "eager" */ "/codebuild/output/src592612800/src/mtalkz.com/components/dynamic-zone/TutorialVideo/TutorialVideo.tsx");
;
import(/* webpackMode: "eager" */ "/codebuild/output/src592612800/src/mtalkz.com/components/dynamic-zone/TwoColumnCTA/TwoColumnCTA.tsx");
;
import(/* webpackMode: "eager" */ "/codebuild/output/src592612800/src/mtalkz.com/components/dynamic-zone/TwoColumnFeatures/TwoColumnFeatures.tsx");
;
import(/* webpackMode: "eager" */ "/codebuild/output/src592612800/src/mtalkz.com/components/dynamic-zone/TwoColumnIconFeatures/TwoColumnIconFeatures.tsx");
;
import(/* webpackMode: "eager" */ "/codebuild/output/src592612800/src/mtalkz.com/components/dynamic-zone/TwoColumnMessagePreview/TwoColumnMessagePreview.tsx");
;
import(/* webpackMode: "eager" */ "/codebuild/output/src592612800/src/mtalkz.com/components/dynamic-zone/TwoColumnWithAccordion/TwoColumnWithAccordion.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["VideoTestimonialCard"] */ "/codebuild/output/src592612800/src/mtalkz.com/components/dynamic-zone/Videotestimonial/VideoTestimonialCard.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/codebuild/output/src592612800/src/mtalkz.com/components/media-carousel/MediaCarousel.tsx");
;
import(/* webpackMode: "eager" */ "/codebuild/output/src592612800/src/mtalkz.com/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager" */ "/codebuild/output/src592612800/src/mtalkz.com/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/codebuild/output/src592612800/src/mtalkz.com/node_modules/next/dist/shared/lib/lazy-dynamic/dynamic-bailout-to-csr.js");
;
import(/* webpackMode: "eager" */ "/codebuild/output/src592612800/src/mtalkz.com/node_modules/next/dist/shared/lib/lazy-dynamic/preload-chunks.js");
